import type { TreeDataNode } from "antd";
import type { Department } from "../types";

/**
 * Backend bo'limlarni TEKIS ro'yxat sifatida qaytaradi
 * (`{ id, parentId, name, path }`) — daraxt shu yerda, mijoz tomonida quriladi.
 *
 * ⚠️ Qator ota-onasi olingan to'plamda topilmasa (row-level scope filtri
 * tufayli — rahbarga ildizsiz shox kelishi mumkin), u jimgina yo'qolmasligi
 * kerak: bunday qator ildiz sifatida ko'rsatiladi. Faqat `parentId === null`
 * dan boshlab yurish (`byParent.get(null)`) bunday qatorlarni butunlay
 * tashlab ketardi — operator bo'sh daraxtni xatosiz ko'rar edi.
 */
export function buildTree(rows: Department[]): TreeDataNode[] {
	const ids = new Set(rows.map((row) => row.id));
	const byParent = new Map<string | null, Department[]>();

	for (const row of rows) {
		const parentKey = row.parentId !== null && ids.has(row.parentId) ? row.parentId : null;
		const siblings = byParent.get(parentKey) ?? [];
		siblings.push(row);
		byParent.set(parentKey, siblings);
	}

	const toNode = (row: Department): TreeDataNode => ({
		key: row.id,
		title: row.name,
		children: (byParent.get(row.id) ?? []).map(toNode),
	});

	return (byParent.get(null) ?? []).map(toNode);
}
